import { Link } from "react-router-dom";
import { useSiteContent } from "@/lib/content";
import Logo from "@/components/Logo";
import MobileBookingBar from "@/components/MobileBookingBar";

export default function SiteFooter() {
  const { content } = useSiteContent();
  const c = content?.contact || {};
  return (
    <footer className="border-t border-slate-200 bg-[#F5F5F5] mt-auto text-[#0A1628] pb-20 md:pb-0">
      <div className="max-w-7xl mx-auto px-6 py-10 grid grid-cols-1 md:grid-cols-4 gap-8">
        <div>
          <Logo variant="inline" testId="footer-logo" />
          <p className="text-sm text-[#0A1628]/70 mt-3 leading-relaxed">
            On-demand technicians for the moments tech gets in your way.
          </p>
        </div>
        <div>
          <div className="text-xs font-bold uppercase tracking-wider text-[#0A1628]/60 mb-3">Company</div>
          <div className="flex flex-col gap-2 text-sm text-[#0A1628]">
            <Link to="/about" data-testid="footer-about" className="hover:underline">About us</Link>
            <Link to="/blog" data-testid="footer-blog" className="hover:underline">Blog</Link>
            <Link to="/contact" data-testid="footer-contact" className="hover:underline">Contact</Link>
          </div>
        </div>
        <div>
          <div className="text-xs font-bold uppercase tracking-wider text-[#0A1628]/60 mb-3">Legal</div>
          <div className="flex flex-col gap-2 text-sm text-[#0A1628]">
            <Link to="/privacy" data-testid="footer-privacy" className="hover:underline">Privacy Policy</Link>
            <Link to="/terms" data-testid="footer-terms" className="hover:underline">Terms of Service</Link>
          </div>
        </div>
        <div>
          <div className="text-xs font-bold uppercase tracking-wider text-[#0A1628]/60 mb-3">Reach us</div>
          <div className="flex flex-col gap-1 text-sm text-[#0A1628]">
            <span data-testid="footer-email">{c.email}</span>
            <span data-testid="footer-whatsapp">WhatsApp: {c.whatsapp}</span>
            <span data-testid="footer-service-area">{c.service_area}</span>
          </div>
        </div>
      </div>
      <div className="border-t border-slate-300 py-5">
        <div className="max-w-7xl mx-auto px-6 text-xs text-[#0A1628]/70 flex flex-wrap items-center justify-between gap-2">
          <span>© {new Date().getFullYear()} Yonsii Geek Support. All rights reserved.</span>
          <span>Built with care in {c.service_area || "Dwarka, Delhi"}.</span>
        </div>
      </div>
      <MobileBookingBar />
    </footer>
  );
}
